import Table from "./Table";
import { FooterComponents as Summary } from "./Footer";
import Column from "./sugar/Column";
import ColumnGroup from "./sugar/ColumnGroup";
import { INTERNAL_COL_DEFINE } from "./utils/legacyUtil";
export { Summary, Column, ColumnGroup, INTERNAL_COL_DEFINE };
export default Table;